import { createContext } from "react";

export const PedidosDetalleContext = createContext()
export const PedidosDetalleFormContext = createContext()
export const PedidosDetalleReportContext = createContext()